import Vue from "vue";
import Vuex from "vuex";
import endpoint from "../views/Commons/Services/index";
import { unauthorizedAction } from "../helpers/commons.helpers";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    locations: [],
    branchesOptionsByOperatorId: [],
    customerOptions: [],
    customerResponse: {},
    responseStatsCard: {},
    countries: [],
    branchesOptions: [],
    operatorSelections: [],
    reservations: [],
    branchesByOperatorId: {},
    responseReservations: {},
    operatorResponse: {},
    responseBranch: {},
    responseAreaByBranch: {},
    responseHistory: {},
    responseArea: {},
    filterText: new RegExp(""),
    sesion:
      localStorage.getItem("es-login") !== null
        ? JSON.parse(localStorage.getItem("es-login"))
        : null,
    load: false,
    profile: {
      first_name: "",
      last_name: "",
      url_picture: "",
      status: false
    },
    areas: [],
    pagination: {},
    ExtraModal: false,
    vehicles: {},
    vehiclesByBranchId: [],
    ModalSchedule: false,
    drivers: {},
    sigout: false,
    usersResponse: {},
    settings: {
      maximumDistance: 0,
      measurementUnit: "miles",
      language: "en",
      currency: "",
      timeZone: "",
      timeFormat: "",
      dateFormat: "",
      brand: {
        colors: {
          buttonText: "#FFFFFF",
          inTheme: false,
          primary: "#000000"
        },
        logos: {
          default: "",
          favicon: ""
        },
        pickupSign: false,
        theme: {
          buttonText: "#FFFFFF",
          color: "#000000"
        }
      },
      permissions: {
        brand: false,
        notifications: false
      }
    },
    rates: {},
    itemsBread: [],
    paginationLimit: 15,
    tempPagination: {
      currenPage: 1,
      query: "",
      queryTemp: "",
      filteredTabStatus: "all",
      limit: 1,
      status: false
    },

    systemInfo: {
      name: "Mobility Suppliers",
      year: new Date().getFullYear(),
      release: {
        version: "0.0.0"
      }
    },
    toggled: false,
    localCurrency: null,
    metaTags: [],
    customersSearchCriteria: {
      currentPage: 1,
      query: "",
      limit: 1,
      status: false
    },
    driversSearchCriteria: {
      currentPage: 1,
      query: "",
      limit: 1,
      status: false
    },
    vehiclesSearchCriteria: {
      currentPage: 1,
      query: "",
      limit: 1,
      status: false
    },
    usersSearchCriteria: {
      currentPage: 1,
      query: "",
      limit: 1,
      status: false
    },
    ratesSearchCriteria: {
      currentPage: 1,
      query: "",
      limit: 1,
      status: false
    },
    areasSearchCriterial: {
      currentPage: 1,
      query: "",
      limit: 1,
      status: false
    },
    branchesSearchCriteria: {
      currentPage: 1,
      query: "",
      limit: 1,
      status: false
    },
    moduleSettings: {},
    latestNewsAvailable: false
  },
  mutations: {
    setSettings: (state, settings) => {
      localStorage.setItem("settings", JSON.stringify(settings));
      state.settings = settings;
    },
    setModuleSettings: (state, moduleSettings) => {
      localStorage.setItem("moduleSettings", JSON.stringify(moduleSettings));
      state.moduleSettings = moduleSettings;
    },
    setProfile: (state, profile) => {
      state.profile = profile;
    },
    setPagination: (state, pagination) => {
      state.pagination = pagination;
    },
    setResponseAreaByBranch: (state, responseAreaByBranch) => {
      state.responseAreaByBranch = responseAreaByBranch;
    },
    setLoad: (state, load) => {
      state.load = load;
    },
    setAdvancedSearch: (state, advancedSearch) => {
      state.advancedSearch = advancedSearch;
      localStorage.setItem("rhombuss-advanced-search", advancedSearch);
    },
    setAreas: (state, areas) => {
      state.areas = areas;
    },
    setLocatons: (state, locations) => {
      state.locations = locations;
    },
    setRatesOfBranch: (state, rates) => {
      state.rates = rates;
    },
    setCountries: (state, countries) => {
      state.countries = countries;
    },
    setResponseArea: (state, responseArea) => {
      state.responseArea = responseArea;
    },
    setOperatorRespose: (state, operatorResponse) => {
      state.operatorResponse = operatorResponse;
    },
    setResponseBranch: (state, responseBranch) => {
      state.responseBranch = responseBranch;
    },
    setResponseStats: (state, responseStatsCard) => {
      state.responseStatsCard = responseStatsCard;
    },
    setCustomerResponse: (state, customerResponse) => {
      state.customerResponse = customerResponse;
    },
    setbranchesOptions: (state, branchesOptions) => {
      state.branchesOptions = branchesOptions;
    },
    setReservatios: (state, reservations) => {
      state.reservations = reservations;
    },
    setSesion: (state, sesion) => {
      state.sesion = sesion;
    },
    setbranchesByOperatorId: (state, branchesByOperatorId) => {
      state.branchesByOperatorId = branchesByOperatorId;
    },
    setbranchesOptionsByOperatorId: (state, branchesOptionsByOperatorId) => {
      state.branchesOptionsByOperatorId = branchesOptionsByOperatorId;
    },
    setOperatorSelections: (state, operatorSelections) => {
      state.operatorSelections = operatorSelections;
    },
    setResponseReservations: (state, responseReservations) => {
      state.responseReservations = responseReservations;
    },
    setFilterText: (state, filterText) => {
      state.filterText = filterText;
    },
    setExtraModal: (state, ExtraModal) => {
      state.ExtraModal = ExtraModal;
    },
    setVehicles: (state, vehicles) => {
      state.vehicles = vehicles;
    },
    setVehiclesByBranchId: (state, vehiclesByBranchId) => {
      state.vehiclesByBranchId = vehiclesByBranchId;
    },
    setModalSchedule: (state, ModalSchedule) => {
      state.ModalSchedule = ModalSchedule;
    },
    setDrivers: (state, drivers) => {
      state.drivers = drivers;
    },
    setSigOut: (state, sigout) => {
      state.sigout = sigout;
    },
    setCustomerOptions(state, customerOptions) {
      state.customerOptions = customerOptions;
    },
    setItemsBread(state, itemsBread) {
      state.itemsBread = itemsBread;
    },
    setTempPagination(state, pagination) {
      state.tempPagination = pagination;
    },
    setToggled: (state, toggled) => {
      state.toggled = toggled;
    },
    setLocalCurrency: (state, localCurrency) => {
      state.localCurrency = localCurrency;
    },
    setMetaTags: (state, metaTags) => {
      state.metaTags = metaTags;
    },
    setCustomersSearchCriteria: (state, customersSearchCriteria) => {
      state.customersSearchCriteria = customersSearchCriteria;
    },
    setDriversSearchCriteria: (state, driversSearchCriteria) => {
      state.driversSearchCriteria = driversSearchCriteria;
    },
    setVehiclesSearchCriteri: (state, vehiclesSearchCriteria) => {
      state.vehiclesSearchCriteria = vehiclesSearchCriteria;
    },
    setUsersSearchCriteria: (state, usersSearchCriteria) => {
      state.usersSearchCriteria = usersSearchCriteria;
    },
    setRatesSearchCriteria: (state, ratesSearchCriteria) => {
      state.ratesSearchCriteria = ratesSearchCriteria;
    },
    setAreasSearchCriteria: (state, areasSearchCriterial) => {
      state.areasSearchCriterial = areasSearchCriterial;
    },
    setBranchesSearchCriteria: (state, branchesSearchCriteria) => {
      state.branchesSearchCriteria = branchesSearchCriteria;
    },
    setLatestNewsAvailable: (state, latestNewsAvailable) => {
      state.latestNewsAvailable = latestNewsAvailable;
    },
    setSystemInfo: (state, systemInfo) => {
      state.systemInfo = systemInfo;
    }
  },
  actions: {
    getModuleSettings: ({ commit, state }) => {
      try {
        state.moduleSettings = JSON.parse(
          localStorage.getItem("moduleSettings")
        );
      } catch (error) {
        state.settings = state.moduleSettings;
      }
    },
    getCountries: ({ commit, state }) => {
      try {
        endpoint.countries.services
          .getCountries()
          .then(response => {
            if (response.data.code === 200) {
              state.countries = response.data.data;
            } else {
              state.countries = [];
            }
          })
          .catch(err => {
            state.countries = [];
            let auth = unauthorizedAction(error);
            if (auth) {
              commit("setSigOut", true);
            }
          });
      } catch (error) {
        state.countries = [];
      }
    },
    async getCustomers({ commit, state }, payload) {
      try {
        let { loader, limit, page, query } = payload;
        commit("setLoad", loader);
        let { data } = await endpoint.customers.services.getCustomers(
          limit,
          page,
          query,
          state.sesion.token
        );
        commit("setLoad", false);
        if (data) {
          state.customerResponse = data;
        } else {
          state.customerResponse = {};
        }
      } catch (error) {
        commit("setLoad", false);
        state.customerResponse = {};
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    getSesion({ commit, state }) {
      try {
        if (localStorage.getItem("es-login") !== null) {
          state.sesion = JSON.parse(localStorage.getItem("es-login"));
        } else {
          state.sesion = null;
        }
      } catch (error) {
        state.sesion = null;
      }
    },
    async getOperatorsSelections({ commit, state }) {
      try {
        let { data } = await endpoint.operators.services.getOperators(
          state.sesion.token
        );
        if (data.status) {
          state.operatorSelections = data.data;
        } else {
          state.operatorSelections = [];
        }
      } catch (error) {
        state.operatorSelections = [];
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    async getBranchesByOperatorId({ commit, state }, data) {
      try {
        commit("setLoad", true);
        let { data } = await endpoint.branches.services.getBranchesByOperatorId(
          data._id,
          data.pagination,
          state.sesion.token
        );
        commit("setLoad", false);
        if (data) {
          state.branchesByOperatorId = data;
        } else {
          state.branchesByOperatorId = {};
        }
      } catch (error) {
        state.branchesByOperatorId = {};
        commit("setLoad", false);
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    async getBranchesOptionsByOperatorId({ commit, state }, operatorId) {
      try {
        let {
          data
        } = await endpoint.branches.services.getBranchesOptionsByOperatorId(
          operatorId,
          state.sesion.token
        );
        if (data) {
          state.branchesOptionsByOperatorId = data.data;
        } else {
          state.branchesOptionsByOperatorId = [];
        }
      } catch (error) {
        state.branchesOptionsByOperatorId = [];
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    async getBranches({ commit, state }, payload) {
      try {
        let { loader, limit, page, query } = payload;
        commit("setLoad", loader);
        let { data } = await endpoint.branches.services.getBranches(
          limit,
          page,
          query,
          state.sesion.token
        );
        commit("setLoad", false);
        if (data) {
          state.responseBranch = data;
        } else {
          state.responseBranch = {};
        }
      } catch (error) {
        commit("setLoad", false);
        state.responseBranch = {};
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    getStatsCards({ commit, state }) {
      try {
        endpoint.dashboard.services
          .getStatsCard()
          .then(response => {
            state.responseStatsCard = response.data;
          })
          .catch(error => {
            state.responseStatsCard = {};
            let auth = unauthorizedAction(error);
            if (auth) {
              commit("setSigOut", true);
            }
          });
      } catch (error) {
        state.responseStatsCard = {};
      }
    },

    async getBranchesOptions({ commit, state }) {
      try {
        let { data } = await endpoint.branches.services.getBranchesOptions(
          state.sesion.token
        );
        if (data.status) {
          state.branchesOptions = data.data;
        } else {
          state.branchesOptions = [];
        }
      } catch (error) {
        state.branchesOptions = [];
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    async getRates({ commit, state }, payload) {
      try {
        let { loader, limit, page, query } = payload;
        commit("setLoad", loader);
        let { data } = await endpoint.rates.services.getRates(
          limit,
          page,
          query,
          state.sesion.token
        );
        commit("setLoad", false);
        if (data) {
          state.rates = data;
        } else {
          state.rates = {};
        }
      } catch (error) {
        state.rates = {};
        commit("setLoad", false);
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    async getRatesByBranchId({ commit, state }, payload) {
      try {
        let { loader, branchId, limit, page, query } = payload;
        commit("setLoad", loader);
        let { data } = await endpoint.rates.services.getRatesByBranchId(
          branchId,
          limit,
          page,
          query,
          state.sesion.token
        );
        commit("setLoad", false);
        if (data) {
          state.rates = data;
        } else {
          state.rates = {};
        }
      } catch (error) {
        console.log(error);
        state.rates = {};
        commit("setLoad", false);
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    getLocations({ commit, state }, input) {
      try {
        endpoint.countries.services
          .autocompleteLocations()
          .then(response => {
            if (response.data.code === 200) {
              state.locations = response.data.code;
            } else {
              state.locations = [];
            }
            error;
          })
          .catch(error => {
            state.locations = [];
            let auth = unauthorizedAction(error);
            if (auth) {
              commit("setSigOut", true);
            }
          });
      } catch (error) {
        state.locations = [];
      }
    },
    async getCustomerOptions({ commit, state }) {
      try {
        let { data } = await endpoint.customers.services.customerOptions(
          state.sesion.token
        );
        if (data) {
          let customers = data.data || [];
          state.customerOptions = customers.sort(function (a, b) {
            if (a.type === "customer" && b.type === "customer") {
              return a.first_name.localeCompare(b.first_name);
            } else {
              return a.company_name.localeCompare(b.company_name);
            }
          });
        } else {
          state.customerOptions = [];
        }
      } catch (error) {
        state.customerOptions = [];
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    async getReservations({ commit, state }, payload) {
      try {
        let { loader, limit, page, query } = payload;
        commit("setLoad", loader);
        let { data } = await endpoint.reservations.services.getReservations(
          limit,
          page,
          query,
          state.sesion.token
        );
        commit("setLoad", false);
        if (data.status) {
          state.responseReservations = data.data;
        } else {
          state.responseReservations = {};
        }
      } catch (error) {
        commit("setLoad", false);
        state.responseReservations = {};
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    async getAreas({ commit, state }, payload) {
      try {
        let { loader, limit, page, query } = payload;
        commit("setLoad", loader);
        let { data } = await endpoint.areas.services.getAreas(
          limit,
          page,
          query,
          state.sesion.token
        );
        commit("setLoad", false);
        if (data) {
          state.responseArea = data;
        } else {
          state.responseArea = {};
        }
      } catch (error) {
        commit("setLoad", false);
        state.responseArea = {};
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    async getAreasByBranchId({ commit, state }, payload) {
      try {
        let { loader, branchId, limit, page } = payload;
        commit("setLoad", loader);
        let { data } = await endpoint.areas.services.getAreasByBranchId(
          branchId,
          limit,
          page,
          state.sesion.token
        );
        commit("setLoad", false);
        if (data) {
          state.responseAreaByBranch = data;
        } else {
          state.responseAreaByBranch = {};
        }
      } catch (error) {
        commit("setLoad", false);
        state.responseAreaByBranch = {};
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    getHistoriesByReservationId({ commit, state }, data) {
      try {
        commit("setLoad", true);
        let user = state.sesion;
        let token = user.token;
        endpoint.reservations.services
          .getHistoriesByReservationId(data._id, data.pagination, token)
          .then(response => {
            commit("setLoad", false);
            if (response.data) {
              state.responseHistory = response.data;
            } else {
              state.responseHistory = {};
            }
          })
          .catch(error => {
            commit("setLoad", false);
            state.responseHistory = {};
            let auth = unauthorizedAction(error);
            if (auth) {
              commit("setSigOut", true);
            }
          });
      } catch (error) {
        commit("setLoad", false);
        state.responseHistory = {};
      }
    },
    getModalExtra: ({ commit, state }, status) => {
      state.ExtraModal = status;
    },
    /**Module vehicles */

    async getVehicles({ commit, state }, payload) {
      try {
        let { loader, limit, page, query } = payload;
        commit("setLoad", loader);
        let { data } = await endpoint.vehicles.services.getVehicles(
          limit,
          page,
          query,
          state.sesion.token
        );
        commit("setLoad", false);
        if (data) {
          state.vehicles = data;
        } else {
          state.vehicles = {};
        }
      } catch (error) {
        commit("setLoad", false);
        state.vehicles = {};
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    async getVehiclesByBranchId({ commit, state }, branchId) {
      try {
        let { data } = await endpoint.vehicles.services.getVehiclesByBranchId(
          branchId,
          state.sesion.token
        );
        if (data) {
          state.vehiclesByBranchId = data;
        } else {
          state.vehiclesByBranchId = [];
        }
      } catch (error) {
        state.vehiclesByBranchId = [];
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    getModalSchedule: ({ commit, state }, status) => {
      try {
        state.ModalSchedule = status;
      } catch (error) {
        state.ModalSchedule = status;
      }
    },
    async getDrivers({ commit, state }, payload) {
      try {
        let { loader, limit, page, query } = payload;
        commit("setLoad", loader);
        let { data } = await endpoint.drivers.services.getDrivers(
          limit,
          page,
          query,
          state.sesion.token
        );
        commit("setLoad", false);
        if (data.status) {
          state.drivers = data.data;
        } else {
          state.drivers = {};
        }
      } catch (error) {
        commit("setLoad", false);
        state.drivers = {};
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    async getUsers({ commit, state }, payload) {
      try {
        let { loader, limit, page, query } = payload;
        commit("setLoad", loader);
        let { data } = await endpoint.users.services.getUsers(
          limit,
          page,
          query,
          state.sesion.token
        );
        commit("setLoad", false);
        if (data.status) {
          state.usersResponse = data.data;
        } else {
          state.usersResponse = {};
        }
      } catch (error) {
        commit("setLoad", false);
        state.usersResponse = {};
        let auth = unauthorizedAction(error);
        if (auth) {
          commit("setSigOut", true);
        }
      }
    },
    async getAdvancedSearch({ commit, state }) {
      if (localStorage.getItem("rhombuss-advanced-search")) {
        state.advancedSearch = localStorage.getItem("rhombuss-advanced-search");
      } else {
        state.advancedSearch = "";
      }
    },
    async getLimit({ commit, state }) {
      if (localStorage.getItem("pagination-limit")) {
        state.paginationLimit = parseInt(
          localStorage.getItem("pagination-limit")
        );
      } else {
        state.paginationLimit = 15;
      }
    },
    getToggledMenu({ commit, state }, status) {
      state.toggled = status;
    },
    getMetas({ commit, state }, metaTagParams) {
      state.metaTags = {
        title: metaTagParams.titlePage,
        meta: [
          {
            name: "description",
            content: metaTagParams.descriptionPage
          },
          {
            name: "keywords",
            content:
              "RhomTrip, Rhomtrip, Europe Shuttle, EuropeShuttle, europe, shuttle, shuttles, worldwide, airport, private, transfers, chauffeur, chauffeurs, services, service, transport, transportation, vehicle, vehicles, limousine, van, vans, minivan, minivans, sedan, mini-buses, buses, transportation, group, reservation, reservations, booking, bookings, reserve, book, train, rail, port, journey, hourly, hotel, event, events, Road Shows, sport, travel, passenger, traveless, passengers, customer, customers, business, company, companies, destination, destinations, contact, USA, united states, eeuu, UK, United Kingdom, Argentina,Australia,Austria,Azerbaijan,Barbados,Belarus,Belgium,Bolivia ,Brazil,Cambodia,Canada,Chile,China,Colombia,Costa Rica,Cyprus,Czech Republic,Denmark,Dominican Republic,Ecuador,El Salvador,Estonia,Finland,France,French Polynesia,Germany,Greece,Hong Kong,Hungary,Iceland,India,Indonesia,Ireland,Israel,Italy,Jamaica,Japan,Korea (Republic of),Latvia,Lithuania,Luxembourg,Malaysia,Mali,Malta,Mexico,Mongolia,Montenegro,Morocco,Netherlands,New Zealand,Nigeria,Norway,Panama,Peru,Poland,Portugal,Puerto Rico,Qatar,Romania,Russian Federation,Senegal,Serbia,Singapore,Slovakia,Slovenia,South Africa,Spain,Sweden,Switzerland,Tanzania, United Republic of,Thailand,Turkey,Ukraine,United Arab Emirates,United Kingdom of Great Britain and Northern Ireland,United States of America,Uruguay,Uzbekistan,Zambia,Nassau,Bahamas,Antigua and barbuda,Saint John,Los Cabos,Bosnia and Herzegovina,Sarajevo,St. Louis,Moldova,Chișinău,Sri lanka,colombo" +
              metaTagParams.keywords
          },
          {
            property: "og:title",
            content: metaTagParams.titlePage
          },
          {
            property: "og:description",
            content: metaTagParams.descriptionPage
          },
          {
            property: "og:image",
            content: window.location.origin + metaTagParams.patchImg
          },
          {
            property: "og:image:alt",
            content: metaTagParams.imgAlt
          },
          {
            property: "og:image:type",
            content: metaTagParams.imgType
          },
          {
            property: "og:url",
            content: window.location.href
          },
          {
            property: "og:locale",
            content: metaTagParams.langPage
          },
          {
            itemprop: "thumbnailUrl",
            content: window.location.origin + metaTagParams.patchImg
          },
          {
            itemprop: "name",
            content: metaTagParams.titlePage
          },
          {
            itemprop: "description",
            content: metaTagParams.descriptionPage
          },
          {
            itemprop: "image",
            content: window.location.origin + metaTagParams.patchImg
          }
        ],
        link: [
          {
            rel: "canonical",
            href: window.location.href
          }
        ]
      };
    }
  },
  getters: {
    locations: state => state.locations,
    customerResponse: state => state.customerResponse,
    branchesOptions: state => state.branchesOptions,
    reservations: state => state.reservations,
    sesion: state => state.sesion,
    operatorResponse: state => state.operatorResponse,
    responseArea: state => state.responseArea,
    responseAreaByBranch: state => state.responseAreaByBranch,
    responseBranch: state => state.responseBranch,
    responseStatsCard: state => state.responseStatsCard,
    branchesByOperatorId: state => state.branchesByOperatorId,
    branchesOptionsByOperatorId: state => state.branchesOptionsByOperatorId,
    operatorSelections: state => state.operatorSelections,
    countries: state => state.countries,
    customerOptions: state => state.customerOptions,
    responseReservations: state => state.responseReservations,
    responseHistory: state => state.responseHistory,
    filterText: state => state.filterText,
    advancedSearch: state => state.advancedSearch,
    load: state => state.load,
    profile: state => state.profile,
    areas: state => state.areas,
    pagination: state => state.pagination,
    ExtraModal: state => state.ExtraModal,
    vehicles: state => state.vehicles,
    vehiclesByBranchId: state => state.vehiclesByBranchId,
    drivers: state => state.drivers,
    sigout: state => state.sigout,
    usersResponse: state => state.usersResponse,
    settings: state => state.settings,
    moduleSettings: state => state.moduleSettings,
    rates: state => state.rates,
    itemsBread: state => state.itemsBread,
    paginationLimit: state => state.paginationLimit,
    tempPagination: state => state.tempPagination,
    toggled: state => state.toggled,
    localCurrency: state => state.localCurrency,
    metaTags: state => state.metaTags,
    customersSearchCriteria: state => state.customersSearchCriteria,
    driversSearchCriteria: state => state.driversSearchCriteria,
    vehiclesSearchCriteria: state => state.vehiclesSearchCriteria,
    usersSearchCriteria: state => state.usersSearchCriteria,
    ratesSearchCriteria: state => state.ratesSearchCriteria,
    areasSearchCriterial: state => state.areasSearchCriterial,
    branchesSearchCriteria: state => state.branchesSearchCriteria,
    latestNewsAvailable: state => state.latestNewsAvailable,
    systemInfo: state => state.systemInfo
  }
});
